import { ref } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { getOrgListFetch, getUserListFetch } from '@/api/userbook';
import UserModalSelect from '@/components/Userbook/select.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'UserModal',
  props: {
    modalVisible: Boolean
  },
  emits: ['update:modalVisible', 'returnUserList'],
  setup(__props, {
    emit
  }) {
    const disabledUserList = ref([]);
    const apiParam = ref({
      isNeedPerm: 0,
      isNeedMainDep: 1
    });
    const selectedUserList = ref([]);
    const selectedCheckedUser = item => {
      selectedUserList.value = item;
    };
    const closeModal = () => {
      emit('update:modalVisible', false);
    };
    const returnUserList = () => {
      emit('returnUserList', selectedUserList.value);
      closeModal();
    };
    return (_ctx, _cache) => {
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        open: __props.modalVisible,
        centered: "",
        width: "900px",
        onCancel: closeModal,
        title: "选择发送对象",
        onOk: returnUserList
      }, {
        default: _withCtx(() => [_createVNode(UserModalSelect, {
          disabledUserList: disabledUserList.value,
          paramOfApi: apiParam.value,
          searchOrgListApi: _unref(getOrgListFetch),
          orgIconBgColor: "#3e19de",
          searchUserListApi: _unref(getUserListFetch),
          onSelect: selectedCheckedUser
        }, null, 8, ["disabledUserList", "paramOfApi", "searchOrgListApi", "searchUserListApi"])]),
        _: 1
      }, 8, ["open"]);
    };
  }
});